import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=2041d201&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2041d201')) {
      api.createRecord('2041d201', component.options)
    } else {
      api.reload('2041d201', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=2041d201&", function () {
      api.rerender('2041d201', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ssG4L5bpdwiN/JS/pricehelp.vue"
export default component.exports